import { NavLink } from 'react-router-dom';
import { Home, Ticket, Trophy, User, ShoppingBag } from 'lucide-react';
import clsx from 'clsx';

export const BottomNav = () => {
  const links = [
    { to: '/', icon: Home, label: 'Главная' },
    { to: '/raffles', icon: Ticket, label: 'Розыгрыши' },
    { to: '/tickets', icon: ShoppingBag, label: 'Билеты' },
    { to: '/jackpot', icon: Trophy, label: 'Джекпот' },
    { to: '/profile', icon: User, label: 'Профиль' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 safe-area-inset-bottom">
      <div className="max-w-7xl mx-auto px-2">
        <div className="flex justify-around">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                clsx(
                  'flex flex-col items-center py-2 px-3 text-xs transition-colors',
                  isActive
                    ? 'text-telegram-button'
                    : 'text-gray-500 dark:text-gray-400'
                )
              }
            >
              {({ isActive }) => (
                <>
                  <link.icon
                    size={24}
                    className={clsx(
                      isActive && 'stroke-2'
                    )}
                  />
                  <span className="mt-1">{link.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
};
